module.exports = __webpack_public_path__ + "img/7.44ceaf8e.png";